import React from 'react';
import './Pages.css';
import { Link } from 'react-router-dom';
import grumanTigerImage from '../media/sunrise.png';

const Home = () => {
  const aircraftSpecs = [
    {
      title: "Aircraft",
      items: ["1978 Grumman Tiger"]
    },
    {
      title: "Recent Updates",
      items: [
        "New Paint - Nov 2020",
        "Penn Yan Aero Overhaul - Sept 2017",
        "New Instrument Panel - 2018"
      ]
    },
    {
      title: "Avionics",
      items: [
        "Electroair 41000 Electronic Ignition",
        "Dual Garmin G5's - AI & HSI",
        "Garmin GTN 650 IFR GPS",
        "Garmin GFC 500 Autopilot",
        "Garmin GNC 255A Navcomm w/ Glideslope",
        "Garmin GTX 345 ADS-B Transponder",
        "PS Engineering PMA 450B Audio Panel",
        "JPI EDM 830 engine monitor w/ fuel flow",
        "Alpha Systems - Angle of Attack Indicator"
      ]
    }
  ];

  return (
    <div className="page-container">
      <div className="hero-section">
        <img src={grumanTigerImage} alt="1978 Grumman Tiger" className="hero-background" />
        <div className="hero-content">
          <h1 className="page-title" id="home-header">THE BEST OF EVERYTHING</h1>
          <Link to="/join" className="cta-button">Join Us</Link>
        </div>
      </div>


      <div className="aircraft-specs">
        {aircraftSpecs.map((section, index) => (
          <div key={index} className="specs-section">
            <h2>{section.title}</h2>
            <ul>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="cta-section">
        <h2>Ready to Experience the Best?</h2>
        <p>Join our club and become part of our aviation community.</p>
        <Link to="/join" className="cta-button">Join Us</Link>
        </div>
    </div>
  );
};

export default Home; 